import { Card, Layout, Spin } from 'antd';
import Image from 'next/image';
import CheckEnrollmentCodeStep from './CheckEnrollmentCodeStep/CheckEnrollmentCodeStep';
import SelectCreateOrLoginStep from './SelectCreateOrLogInStep/SelectCreateOrLogInStep';
import CreateAndEnrollStudentStep from './CreateAndEnrollStudentStep/CreateAndEnrollStudentStep';
import EnrollExistingStudentStep from './EnrollExistingStudentStep/EnrollExistingStudentStep';
import { StyledEnrollmentFlow } from './EnrollmentFlow.styled';
import SuccessStep from './SuccessStep/SuccessStep';
import useEnrollmentFlow from './useEnrollmentFlow.hook';
import { Paragraph, Text, Title } from '@/shared/Typography';
import LogInAndEnrollStep from './LoginAndEnrollStep/LogInAndEnrollStep';
import ConfirmPossibleDuplicate from './ConfirmPossibleDuplicate/ConfirmPossibleDuplicate';
import DuplicateLoginStep from './DuplicateLoginStep/DuplicateLoginStep';

const { Content } = Layout;

export default function EnrollmentFlow() {
  const { state, actions } = useEnrollmentFlow();
  return (
    <StyledEnrollmentFlow>
      <Layout>
        <Content>
          <Spin spinning={state.loading}>
            <Card
              width={{ selectCreateOrLogin: 800 }[state.activeStep] ?? 400}
              title={
                <div className="title-image">
                  <Image
                    src={
                      process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
                      '/img/logo.png'
                    }
                    alt="Rockalingua logo"
                    width={258}
                    height={77}
                    layout="responsive"
                    priority
                  />
                </div>
              }
              className="flow-card"
            >
              {state.activeStep != 'checkEnrollmentCode' &&
                state.activeStep != 'enrollExistingStudent' &&
                state.activeStep != 'duplicateLogin' &&
                state.activeStep != 'success' && (
                  <Title align="center" level={4}>
                    You are enrolling in{' '}
                    <span className="teacher-name">{state.teacherName}</span>
                    's{' '}
                    <strong>
                      <em className="class-name">{state.class?.name}</em> class
                    </strong>
                  </Title>
                )}
              {
                {
                  checkEnrollmentCode: (
                    <CheckEnrollmentCodeStep
                      flowActions={actions.flowActions}
                    />
                  ),
                  /* selectCreateOrLogin: (
                    <SelectCreateOrLoginStep
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ),
                  loginAndEnroll: (
                    <LogInAndEnrollStep
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ),
                  enrollExistingStudent: (
                    <EnrollExistingStudentStep
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ), */
                  createAndEnrollStudent: (
                    <CreateAndEnrollStudentStep
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ),
                  confirmPossibleDuplicate: (
                    <ConfirmPossibleDuplicate
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ),
                  duplicateLogin: (
                    <DuplicateLoginStep
                      flowState={state}
                      flowActions={actions.flowActions}
                    />
                  ),
                  success: <SuccessStep flowState={state} />,
                }[state.activeStep]
              }
            </Card>
          </Spin>
        </Content>
      </Layout>
    </StyledEnrollmentFlow>
  );
}
